






















































































































































































































/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
import Vue from "vue";
// import { startOfDay } from "date-fns";
import { State, Action, Mutation } from "vuex-class";
import Component from "vue-class-component";
import { FacebookState } from "../../../store/facebook";
import moment from "moment";
import momentTz from "moment-timezone";
import AudiencesList from "./AudiencesList.vue";

import FbService from "../../../services/facebook";

const namespace = "facebook";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const countries = require("../../../assets/countries.json");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const devices = require("../../../assets/devices.json");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const locales = require("../../../assets/locales.json");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const accountInfo = require("../../../assets/accountToPages.json");

@Component({
  components: {
    AudiencesList
  }
})
export default class SelectedCampaings extends Vue {
  @State("facebook") facebook: FacebookState;
  @Action("fetchCampaigns", { namespace }) fetchCampaigns: any;
  @Mutation("selectCampaign", { namespace }) selectCampaign: any;
  @Mutation("unSelectCampaign", { namespace }) unSelectCampaign: any;
  @Mutation("unSelectAllCampaign", { namespace }) unSelectAllCampaign: any;
  @Mutation("addError", { namespace }) addError: any;

  @Mutation("resetSelectedAdvideos", { namespace }) resetSelectedAdvideos: any;
  @Mutation("resetCampaigns", { namespace }) resetCampaigns: any;

  title = "";
  loading = false;
  headers = [
    { text: "Name", value: "name", sortable: false },
    { text: "Status", value: "status", sortable: false },
    { text: "Daily Budjet", value: "daily_budget", sortable: false },
    { text: "Remove", value: "isSelected", sortable: false }
  ];
  countries = countries;
  devices = devices;
  locales = locales;
  accountInfo = accountInfo;
  audiences = [];

  deviceSearch = "";
  countrySearch = "";
  localeSearch = "";
  searchAudience = "";

  creatingCampaigns = false;
  successOverlay = false;

  nameRegExp = /^(\w{2}?) ?(\w{2}\+*?\w{0,2})? *?(lc|tc|bc)? \d{1,2} \w{3} *?(?=.*(ios|andr).*|)/i;

  appStores = [
    {
      key: "ITunes",
      value: "itunes"
    },
    {
      key: "GooglePlay",
      value: "google"
    }
  ];

  supportedAndroinVersions = [
    "2.0",
    "2.1",
    "2.2",
    "2.3",
    "3.0",
    "3.1",
    "3.2",
    "4.0",
    "4.1",
    "4.2.",
    "4.3",
    "4.4",
    "5.0",
    "5.1",
    "6.0",
    "7.0",
    "7.1"
  ];

  supportedIOSVersions = [
    "2.0",
    "3.0",
    "4.0",
    "4.3",
    "5.0",
    "6.0",
    "7.0",
    "8.0",
    "9.0"
  ];

  startDate = moment(new Date()).format("YYYY-MM-DD");

  osVersions = [];

  appStoreLinks: { [key: string]: any } = {
    // sudoku
    "421689338778058": {
      google:
        "http://play.google.com/store/apps/details?id=com.universeapps.sudoku",
      itunes: "https://itunes.apple.com/app/id1040149161"
    },
    // translator
    "2214637462124033": {
      itunes: "https://itunes.apple.com/app/id1458104794"
    },
    // scanguru
    "559745187800171": {
      itunes: "https://itunes.apple.com/app/id1040149161"
    },
    // lap
    "498164330707568": {},
    // cleaner
    "2498086803755292": {
      itunes: "https://itunes.apple.com/app/id1476380919"
    },
    // find differneces
    "185456979397520": {
      google:
        "http://play.google.com/store/apps/details?id=com.universeapps.differences",
      itunes: "https://itunes.apple.com/app/id1499515790"
    },
    // scanner 2
    "1320842784778113": {},
    // blackhole
    "764717670625898": {}
  };

  beforeRouteUpdate(to: any, from: any, next: Function) {
    this.fetch(to.params.accountId);

    this.resetSelectedAdvideos();
    this.resetCampaigns();

    next();
  }
  fetch(accountId: string) {
    this.loading = true;
    this.fetchCampaigns({ accountId }).then(() => {
      this.loading = false;
    });
  }

  get countresToSelect() {
    return !this.countrySearch
      ? this.countries
      : this.countries.filter((c: any) =>
          c.name.toLowerCase().startsWith(this.countrySearch)
        );
  }

  get devicesToSelect() {
    return !this.deviceSearch
      ? this.devices
      : this.devices.filter((c: any) =>
          c.description.toLowerCase().startsWith(this.deviceSearch)
        );
  }

  get localeToSelect() {
    return !this.localeSearch
      ? this.locales
      : this.locales.filter((l: any) =>
          l.name.toLowerCase().startsWith(this.localeSearch)
        );
  }

  get headline() {
    if (!this.facebook.selectedCampaigns[0]) {
      return "";
    }
    const {
      adsets: {
        data: [adset]
      }
    } = this.facebook.selectedCampaigns[0];

    const { title = "" } =
      adset.ads.data[0].creative?.object_story_spec?.video_data ?? {};
    return title;
  }
  set headline(v) {
    this.facebook.campaignHeadline = v;
  }

  get text() {
    if (!this.facebook.selectedCampaigns[0]) {
      return "";
    }
    const {
      adsets: {
        data: [adset]
      }
    } = this.facebook.selectedCampaigns[0];

    const { message = "" } =
      adset.ads.data[0].creative?.object_story_spec?.video_data ?? {};
    return message;
  }

  set text(v) {
    this.facebook.campaignText = v;
  }

  get canCreate() {
    const {
      selectedCampaigns,
      selectedAdvideos
      // campaignHeadline,
      // campaignText
    } = this.facebook;
    return (
      !!selectedCampaigns.length && !!selectedAdvideos.length
      // !!campaignHeadline
    );
  }

  applyBidAmount(value: any, item: any) {
    item.adsets.data[0].bid_amount = Math.round(parseFloat(value) * 100);
  }

  applyPromotedObject(value: any, item: any) {
    const appId = item.adsets.data[0].promoted_object.application_id;
    const default_url = item.adsets.data[0].promoted_object.object_store_url;

    item.adsets.data[0].promoted_object = {
      ...item.adsets.data[0].promoted_object,
      object_store_url: this.appStoreLinks[appId][value]
        ? this.appStoreLinks[appId][value]
        : default_url
    };
  }

  applyDailyBudjet(value: any, item: any) {
    item.daily_budget = Math.round(parseFloat(value) * 100);
  }

  applyAudience(audience: any, item: any) {
    if (!item.adsets.data[0].targeting.custom_audiences) {
      item.adsets.data[0].targeting.custom_audiences = [];
    }
    item.adsets.data[0].targeting.custom_audiences.push(audience);
  }

  formatDate(d: Date) {
    return moment(d)
      .format("DD MMM")
      .toUpperCase();
  }

  campaignName(prevName: string, videoName: string) {
    const removeVideoExt = (str: string) => str.split(".").splice(0, 1);

    const [_, app, region, second, platform, ...apendix] = Array.from(
      prevName.match(this.nameRegExp)!
    );

    return [
      app,
      region,
      second,
      platform,
      this.formatDate(new Date(this.startDate)),
      `(${removeVideoExt(videoName)})`,
      apendix.join(" ")
    ]
      .join(" ")
      .trim();
  }
  // TODO: move to actions
  createCampaigns(type: "video" | "image") {
    // if (!this.text || !this.headline) {
    //   this.addError(new Error("Text or Headline is missing"));
    //   return;
    // }

    if (this.facebook.selectedAdvideos.length) {
      this.creatingCampaigns = true;

      const randomize = (min: number, max: number) =>
        Math.floor(Math.random() * max + min);

      const getRandomAccount = (acccountId: string) => {
        return this.accountInfo[acccountId][
          randomize(0, accountInfo[acccountId].length - 1)
        ];
      };

      const compaignsToCreate = this.facebook.selectedCampaigns.map(
        ({
          adsets: {
            data: [
              {
                ads: {
                  // eslint-disable-next-line no-unused-vars
                  name: _adSetName,
                  data: [
                    {
                      // eslint-disable-next-line no-unused-vars
                      name: _adName,
                      creative: {
                        object_story_spec: {
                          video_data: {
                            // eslint-disable-next-line no-unused-vars
                            image_hash: _removeImgHash,
                            ...video_data
                          },
                          ...object_story_spec
                        },
                        // eslint-disable-next-line no-unused-vars
                        id: _idPlohui,
                        ...creative
                      },
                      // eslint-disable-next-line no-unused-vars
                      id: _adIdToRemove, // NOTE slomaet ih apihu
                      ...ad
                    }
                  ]
                },
                // eslint-disable-next-line no-unused-vars
                id: _poshelIdNahui, // NOTE slomaet ih apihu
                ...adset
              }
            ]
          },
          // eslint-disable-next-line no-unused-vars
          id: poshelNahui, // NOTE slomaet ih apihu
          ...campaign
        }) => [
          {
            ...campaign,
            status: "PAUSED",
            special_ad_categories: ["NONE"],
            name: this.campaignName(
              campaign.name,
              this.facebook.selectedAdvideos[0].title
            )
          },
          {
            ...adset,
            // start_time: this.startDate + " 07:00:00",
            start_time: momentTz
              .tz(`${this.startDate} 24:00:00`, "Asia/Vladivostok")
              .clone()
              .tz("America/Los_Angeles")
              .format("YYYY-MM-DD HH:mm:ss"),
            name: this.campaignName(
              campaign.name,
              this.facebook.selectedAdvideos[0].title
            )
          },
          this.facebook.selectedAdvideos.map(
            ({ title, id: video_id, thumbnails: { data } }) => {
              const account = getRandomAccount(this.$route.params.accountId);
              return {
                name: this.campaignName(campaign.name, title),
                creative: {
                  object_story_spec: {
                    video_data: {
                      ...video_data,
                      video_id,
                      title: encodeURIComponent(this.facebook.campaignHeadline),
                      message: encodeURIComponent(this.facebook.campaignText),
                      image_url: encodeURIComponent(
                        data.find(({ is_preferred }: any) => is_preferred)
                          ?.uri ?? ""
                      )
                    },
                    ...object_story_spec,
                    page_id: account.page_id,
                    instagram_actor_id: account.instagram_actor_id
                  },
                  ...creative,
                  object_type: "SHARE"
                },
                ...ad
              };
            }
          )
          // this.facebook.selectedAdimages.map(
          //   ()
          // ),
        ]
      );

      Promise.all([
        compaignsToCreate.map(d =>
          FbService.createCampaign(this.$route.params.accountId, d)
        )
      ])
        .then(() =>
          this.fetchCampaigns({ accountId: this.$route.params.accountId })
        )
        .catch(err => this.addError(err))
        .finally(() => {
          setTimeout(() => {
            this.creatingCampaigns = false;
            this.successOverlay = true;
          }, 2000);
        });
    }

    if (this.facebook.selectedAdimages.length) {
      this.creatingCampaigns = true;

      const randomize = (min: number, max: number) =>
        Math.floor(Math.random() * max + min);

      const getRandomAccount = (acccountId: string) => {
        return this.accountInfo[acccountId][
          randomize(0, accountInfo[acccountId].length - 1)
        ];
      };
      const compaignsToCreate = this.facebook.selectedCampaigns.map(
        ({
          adsets: {
            data: [
              {
                ads: {
                  // eslint-disable-next-line no-unused-vars
                  name: _adSetName,
                  data: [
                    {
                      // eslint-disable-next-line no-unused-vars
                      name: _adName,
                      creative: {
                        object_story_spec: {
                          link_data,
                          video_data,
                          ...object_story_spec
                        },
                        // eslint-disable-next-line no-unused-vars
                        id: _idPlohui,
                        ...creative
                      },
                      // eslint-disable-next-line no-unused-vars
                      id: _adIdToRemove, // NOTE slomaet ih apihu
                      ...ad
                    }
                  ]
                },
                // eslint-disable-next-line no-unused-vars
                id: _poshelIdNahui, // NOTE slomaet ih apihu
                ...adset
              }
            ]
          },
          // eslint-disable-next-line no-unused-vars
          id: poshelNahui, // NOTE slomaet ih apihu
          ...campaign
        }) => [
          {
            ...campaign,
            status: "PAUSED",
            special_ad_category: "NONE",
            name: this.campaignName(
              campaign.name,
              this.facebook.selectedAdimages[0].name
            )
          },
          {
            ...adset,
            // start_time: this.startDate + " 07:00:00",
            start_time: momentTz
              .tz(`${this.startDate} 24:00:00`, "Asia/Vladivostok")
              .clone()
              .tz("America/Los_Angeles")
              .format("YYYY-MM-DD HH:mm:ss"),
            name: this.campaignName(
              campaign.name,
              this.facebook.selectedAdimages[0].name
            )
          },
          this.facebook.selectedAdimages.map(
            ({ name, hash, url, permalink_url }) => {
              const account = getRandomAccount(this.$route.params.accountId);
              return {
                name: this.campaignName(campaign.name, name),
                creative: {
                  object_story_spec: {
                    ...object_story_spec,
                    link_data: {
                      call_to_action: {
                        type: "INSTALL_APP"
                      },
                      ...link_data,
                      name: encodeURIComponent(this.facebook.campaignHeadline),
                      image_hash: encodeURIComponent(hash),
                      link: adset.promoted_object.object_store_url
                    },
                    page_id: account.page_id,
                    instagram_actor_id: account.instagram_actor_id
                  },
                  ...creative,
                  object_type: "SHARE"
                },
                ...ad
              };
            }
          )
          // this.facebook.selectedAdimages.map(
          //   ()
          // ),
        ]
      );

      Promise.all([
        compaignsToCreate.map(d =>
          FbService.createCampaign(this.$route.params.accountId, d)
        )
      ])
        .then(() =>
          this.fetchCampaigns({ accountId: this.$route.params.accountId })
        )
        .catch(err => this.addError(err))
        .finally(() => {
          setTimeout(() => {
            this.creatingCampaigns = false;
            this.successOverlay = true;
          }, 2000);
        });
    }
  }
}
